import { Modal, Tabs, Tab } from "carbon-components-react";
import { MediaSection } from "components/Media/Media";
import FileDropzone from "forms/inputs/FileDropzone/FileDropzone";
import useMediaGallery from "hooks/useMediaGallery";
import "./MediaGallery.scss";
import { useContext, useEffect, useState } from "react";
import {
    attachMedia,
    deleteMedia,
    getMedia,
    detachMedia,
} from "api/functions/functions";
import MainContext from "context/MainContext";

const MediaGallery = (props) => {
    const context = useContext(MainContext);

    const [eventId, setEventId] = useState(null);
    const [selected, setSelected] = useState(1);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [key, setKey] = useState(1);

    const {
        mediaGalleryOpen,
        mediaGalleryAccept,
        getMediaGalleryAttached,
        closeMediaGallery,
        getAttachTo,
        isMediaGalleryOpen,
        setAttached,
        getGalleryFilters,
        getMediaGalleryOnAttach,
        // onAttachChange
    } = useMediaGallery();

    // useEffect(() => {
    //     if (eventId) {
    //         loadMediaGallery()
    //     }
    // }, [eventId, mediaGalleryAccept])

    useEffect(() => {
        if (mediaGalleryOpen) {
            loadMediaGallery();
            setKey((key) => key + 1);
        }
    }, [mediaGalleryOpen]);

    useEffect(() => {
        const id = context.evt ? context.evt.id : null;
        setEventId(id);
    }, [context.evt]);

    const loadMediaGallery = async () => {
        setLoading(true);
        const data = await getMedia(eventId, {
            ...getAttachTo(),
            mime: mediaGalleryAccept,
        });
        setItems(data);
        setLoading(false);
        return data;
    };

    const afterUploadSuccess = async (e) => {
        await loadMediaGallery();
        setSelected(0);
    };

    const updateAttachments = (attachments) => {
        const filters = getGalleryFilters();
        if (filters) {
            const _attached = [...attachments].filter((a) => {
                let ret = true;
                Object.keys(filters).forEach((f) => {
                    if (a[f] !== filters[f]) {
                        ret = false;
                    }
                });
                return ret;
            });
            attachments = _attached;
        }
        return attachments?.map((item) => item.id) || [];
    };

    const onClickAttach = async (id) => {
        const res = await attachMedia(id, getAttachTo());
        // onAttachChange()
        if (res.data?.attachments) {
            setAttached(updateAttachments(res.data.attachments));
            if (getMediaGalleryOnAttach()) {
                getMediaGalleryOnAttach()(res);
            }
            // setAttached(res.data.attachments.map(item => item.id))
        } else {
            setAttached([id]);
        }
    };

    const onClickDetach = async (id) => {
        const res = await detachMedia(id, getAttachTo());
        if (res.data?.attachments) {
            setAttached(updateAttachments(res.data.attachments));
            // setAttached(res.data.attachments.map(item => item.id))
            if (getMediaGalleryOnAttach()) {
                getMediaGalleryOnAttach()(res);
            }
        } else {
            setAttached();
        }
    };

    const onCLickDelete = async (id) => {
        const res = await deleteMedia(id);
        if (res !== 0) {
            removeFromCollection(id);
        } else {
            alert("error");
        }
    };

    const removeFromCollection = (id) => {
        let newItems = [...items];
        newItems = newItems.filter((item) => item.id !== id);
        setItems(newItems);
    };

    const getModalLabel = () => {
        if (!mediaGalleryAccept) return "All file";
        return mediaGalleryAccept?.join(", ") || "";
    };

    const getModalHeading = () => {
        return "Media gallery";
    };

    const getAttached = () => {
        return isMediaGalleryOpen() ? getMediaGalleryAttached() : [];
    };

    return (
        <Modal
            // buttonTriggerText="Launch modal"
            // modalHeading="Modal heading"
            className="media-gallery-modal"
            passiveModal
            size="lg"
            open={isMediaGalleryOpen()}
            modalLabel={getModalLabel()}
            modalHeading={getModalHeading()}
            hasForm={true}
            onRequestClose={closeMediaGallery}
        >
            <Tabs selected={selected}>
                <Tab
                    label="Use existing"
                    selected={selected === 0}
                    onClick={() => setSelected(0)}
                >
                    <MediaSection
                        onCLickDelete={(id) => onCLickDelete(id)}
                        onClickAttach={(id) => onClickAttach(id)}
                        onClickDetach={(id) => onClickDetach(id)}
                        attached={getAttached()}
                        open={isMediaGalleryOpen()}
                        items={items}
                        loading={loading}
                    />
                </Tab>
                <Tab
                    label="Upload"
                    selected={selected === 1}
                    onClick={() => setSelected(1)}
                >
                    <FileDropzone
                        key={key}
                        eventId={eventId}
                        afterUploadSuccess={afterUploadSuccess}
                    />
                </Tab>
            </Tabs>
        </Modal>
    );
};

export default MediaGallery;
